module.exports = __webpack_public_path__ + "img/top-top2.5b70a557.png";